module.exports = __webpack_public_path__ + "static/img/hua13.d16fb65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hua13.png
// module id = 5MYd
// module chunks = 22